import { Pipe, PipeTransform } from '@angular/core';
import { isString } from 'util';

@Pipe({
  name: 'unslug'
})
export class UnslugPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if (!isString(value)) {
      return value;
    }

    const frags = value.split('_');
    for (let i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(' ').replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/pipes/unslug.pipe.ts